import React, { useEffect } from 'react';

// Versão ATUAL deste código (Deverá ser atualizada manualmente ou via script antes do deploy)
// DICA: Sempre que for fazer um deploy importante, mude este número.
const CURRENT_APP_VERSION = "1790251457696"; 

export default function VersionChecker() {
  
  useEffect(() => {
    const checkVersion = async () => {
      try {
        // Busca o arquivo version.json no servidor
        // O '?t=' serve para garantir que o navegador não pegue do cache
        const response = await fetch(`/version.json?t=${new Date().getTime()}`);
        const data = await response.json();
        
        const serverVersion = data.version;

        console.log(`Versão App: ${CURRENT_APP_VERSION} | Versão Server: ${serverVersion}`);

        if (serverVersion !== CURRENT_APP_VERSION) {
          console.log("Nova versão detectada! Atualizando...");
          
          // Limpa caches do navegador
          if ('caches' in window) {
            const names = await caches.keys();
            await Promise.all(names.map(name => caches.delete(name)));
          }
          
          // Força o recarregamento da página buscando do servidor
          window.location.reload(true);
        }
      } catch (error) {
        console.error("Erro ao verificar versão:", error);
      }
    };

    // Verifica ao carregar a página
    checkVersion();

    // Opcional: Verifica a cada 5 minutos se o usuário deixar a aba aberta
    const interval = setInterval(checkVersion, 5 * 60 * 1000);
    return () => clearInterval(interval);

  }, []);

  return null; // Este componente não renderiza nada visualmente
}